export default "__VITE_ASSET__b32d68c5__"